export default {
    name: "CustomerInviteApply",
    data() {
        return {
            searchForm: {
                rcAuditName: '',
                // 申请类型  1 接受  0 发送
                type: '',
                // 受邀客户审核状态
                auditResult: null,
                // 平台审核状态
                platformAuditResult: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    mounted: function () {
		this.init();
	},
    methods: {
        init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            this.$axios.get('/api/customerCompay/partnershipReview', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doAudit(){
            const row = this.getSelectedRow();
			if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
                conditionData.row = row;
                // 1 受邀  0 邀请
                if (row.type === '1') {
                    if (row.rcAuditResult === '1') {
                        this.$message({
                            message: this.$t('customerApply.message.isAudited'),
                            type: 'warning',
                            center: true
                        });
                        return null
                    }
                    this.$router.push('customerInviteApplyReview');
                } else {
                    this.$message({
                        message: this.$t('customerApply.message.checkTypeAudit'),
                        type: 'warning',
                        center: true
                    });
                    return null
                }
				this.$routerUtil.setParam(conditionData);
			}
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        doReset(){
            this.$refs.searchForm.resetFields();
        },
    }
}
